'use strict';

import _ from 'lodash';
import React from 'react';

import Masthead from './masthead';
import Header from '../common/header';
import Listing from '../common/listing';
import Speaker from '../common/speaker';
import Sponsor from '../common/sponsor';
import Event from '../common/event';
import Analytics from '../common/analytics';

class Landing extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let speakers = _(this.props.conference.current.speakers)
      .filter({ featured_speaker: 'yes' })
      .map((speaker) => { return <Speaker key={speaker._id} speaker={speaker} showPhoto {...this.props} /> })
      .value();

    // if no speakers are marked as featured default to chairpeople or keynotes
    speakers = speakers.length ? speakers : _(this.props.conference.current.speakers)
      .filter((speaker) => { return !!speaker.keynote || !!speaker.chairperson; })
      .map((speaker) => { return <Speaker key={speaker._id} speaker={speaker} showPhoto {...this.props} /> })
      .value();

    let sponsorLevels = _(this.props.conference.current.sponsors)
      .reject((sponsor) => { return sponsor.level === 'exhibitor' })
      .sortBy((sponsor) => { return ['lead-sponsor', 'co-sponsor', 'diamond', 'platinum', 'gold', 'summit-sponsors', 'co-host-summit-sponsor', 'strategic-partnership-sponsor', 'strategic-partner', 'track-sponsors', 'marketing-sponsors', 'exhibition-sponsors', 'innovation-plaza-sponsor', 'ambassador', 'delegation-network', 'sponsor', 'partner', 'associate-sponsor'].indexOf(sponsor.level); })
      .map((sponsor) => { return <Sponsor key={sponsor._id} sponsor={sponsor} showLevel={true} showPhoto={true} {...this.props} /> })
      .groupBy('props.sponsor.level')
      .value();

    let other = _(this.props.conferences.upcoming)
      .reject({ _id: this.props.conference.current._id })
      .slice(0, 4)
      .map((conference) => { return <Event key={conference._id} event={conference} image /> })
      .value();
    
    return <div>
      <Masthead conference={this.props.conference.current} path={this.props.path} />
      {!speakers.length ? null :
        <section className="section featured-speakers">
          <Listing
            elements={speakers}
            limit={3}
            title="Featured Speakers"
            buttonText="View All Speakers"
            buttonLink={this.props.location.pathname + '/speakers'} />
        </section>
      }
      {!Object.keys(sponsorLevels).length ? null :
        _.map(sponsorLevels, (level, k) => {
          k = k !== 'co-sponsor' ? (k !== 'co-host-summit-sponsor' ? _.replace(k,new RegExp('-','g'),' ') : 'Co-host | Summit Sponsor') : k;
           return <section key={k} className="section featured-sponsor">
            <Listing elements={level} title={!k || k === 'sponsor' ? 'Sponsors' : k} />
          </section>
        })
      }
      <section className="section other">
        <Listing
          elements={other}
          limit={4}
          title="Other P&I Conferences"
          buttonText="More info on P&I Conferences"
          buttonLink="//www.pionline.com/conferences?event_type=conference#events" />
      </section>
      <Analytics view="landing" {...this.props} />
    </div>
  }
};

export default Landing;
